import { render } from "preact";
import "./styles.css";
import { initSupabase } from "./lib/supabase";
import { App } from "./app";
import { applyPrefs } from "./lib/prefs";

applyPrefs();

const root = document.getElementById("app")!;
initSupabase()
  .then(() => render(<App />, root))
  .catch((e: Error) => {
    root.innerHTML = `<p class="error" style="padding:2rem">Could not start the app: ${e.message.replace(/</g, "&lt;")}</p>`;
  });
